export const tracking = {
    app: 'BLOG',
    step: {
        init: 'INIT',
        article: {
            clicked: 'ARTICLE_CLICKED',
            init: 'ARTICLE_INIT',
            author: {
                clicked: 'BTN_AUTHOR_PAGE',
            },
        },
        subscribe: {
            formSubscribeButtonClicked: 'BTN_SUBSCRIBE_CLICKED',
            landingSubscribeDialog: {
                open: 'BTN_OPEN_SUBSCRIBE_DIALOG',
                close: 'BTN_CLOSE_SUBSCRIBE_DIALOG',
            },
        },
        tag: {
            clicked: 'TAG_CLICKED',
        },
        author: {
            opened: 'AUTHOR_PAGE_INIT',
        },
    },
};
